<template>
  <div class="phonics">
    <v-row justify="center" class="mt-4">
      <v-col cols="10" sm="12" md="12" lg="12">
        <v-sheet elevation="10" rounded="xl">
          <v-sheet
            class="pa-3 light-blue darken-2 text-center"
            dark
            rounded="t-xl"
          >
            <h4>Words</h4>
          </v-sheet>

          <div class="pa-4">
            <v-chip-group active-class="primary--text" column>
              <v-chip
                v-for="phone in phonics"
                :key="phone"
                @click="
                  setWord(phone.phn);
                  setChivox(phone.phn, phone.refText);
                "
              >
                <div>{{ phone.phn }}</div>
              </v-chip>
            </v-chip-group>
          </div>
        </v-sheet>
      </v-col>
    </v-row>
  </div>
</template>

<script>
// import training from '../views/training.vue';

export default {
  components: {
    // training
  },
  data() {
    return {
      tags: [{ key: "a" }, { key: "b" }],
      phonics: [
        { phn: "a", refText: ["ae"] },
        { phn: "b", refText: ["b"] },
        { phn: "c", refText: ["k"] },
        { phn: "d", refText: ["d"] },
        { phn: "e", refText: ["e"] },
        { phn: "f", refText: ["f"] },
        { phn: "g", refText: ["g"] },
        { phn: "h", refText: ["hh"] },
        { phn: "i", refText: ["i"] },
        { phn: "j", refText: ["jh"] },
        { phn: "k", refText: ["k"] },
        { phn: "l", refText: ["l"] },
        { phn: "m", refText: ["m"] },
        { phn: "n", refText: ["n"] },
        { phn: "o", refText: ["oh"] },
        { phn: "p", refText: ["p"] },
        { phn: "q", refText: ["k"] },
        { phn: "r", refText: ["r"] },
        { phn: "s", refText: ["s"] },
        { phn: "t", refText: ["t"] },
        { phn: "u", refText: ["ah"] },
        { phn: "v", refText: ["v"] },
        { phn: "w", refText: ["w"] },
        { phn: "x", refText: ["k", "s"] },
        { phn: "y", refText: ["j"] },
        { phn: "z", refText: ["z"] },
      ],
    };
  },
};
</script>
